import theme from '@/constants/theme';
import { Lock } from '@mui/icons-material';

const PrivacyNote = () => {
  return (
    <div style={{ display: 'flex', gap: 4, alignItems: 'center', color: theme.colors.text.caption }}>
      <Lock fontSize="small" />
      <h4>Todas tus respuestas son privadas.</h4>
    </div>
  );
};

export default PrivacyNote;
